import { render, staticRenderFns } from "./EstadisticaComponent.vue?vue&type=template&id=5717c0d1&"
import script from "./EstadisticaComponent.vue?vue&type=script&lang=js&"
export * from "./EstadisticaComponent.vue?vue&type=script&lang=js&"
import style0 from "./EstadisticaComponent.vue?vue&type=style&index=0&id=5717c0d1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports